import { render, staticRenderFns } from "./DNSTwisterWatchlist.vue?vue&type=template&id=0f67e223&"
import script from "./DNSTwisterWatchlist.vue?vue&type=script&lang=js&"
export * from "./DNSTwisterWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports